import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AuthStore } from '../auth/auth.store';
import { ApiService } from '../api/api.service';

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const api = inject(ApiService);
  const router = inject(Router);

  if (!authStore.accessToken()) {
    return router.createUrlTree(['/login']);
  }

  if (authStore.me()) {
    return true;
  }

  return api.loadMe().pipe(
    map(() => true),
    catchError(() => {
      authStore.clear();
      return of(router.createUrlTree(['/login']));
    }),
  );
};

export const guestGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  if (authStore.isAuthenticated() && authStore.me()) {
    return router.createUrlTree([postLoginPath(authStore)]);
  }
  return true;
};

export function postLoginPath(authStore: AuthStore): string {
  const me = authStore.me();
  if (!me) return '/login';

  if (me.familyMemberships.length === 0) {
    return '/onboarding';
  }

  const membership = me.familyMemberships[0];
  if (
    membership.role === 'PRIMARY_PARENT' ||
    membership.role === 'SECONDARY_PARENT'
  ) {
    return `/app/parent/${membership.familyId}`;
  }
  if (membership.role === 'GRANDFATHER' || membership.role === 'GRANDMOTHER') {
    return `/app/grandparent/${membership.familyId}`;
  }
  if (me.studentProfileId) {
    return `/app/student/${me.studentProfileId}`;
  }
  return '/onboarding';
}
